const valid_date = function(year, month, day){
  if (year < 0 || year > 3000) return false  // if ub set at 9999, date-picker component may crash on large years
  if (month < 1 || month > 12) return false
  if (day < 1 || day > 31) return false
  var d = new Date(year, month - 1, day)
  if (isNaN(d.getTime())) return false
  return d.getFullYear() == year && d.getMonth() + 1 == month && d.getDate() == day
}

const parse_date = function(date){
  // DD/MM/YYYY to YYYY-MM-DD
  try {
    if (!date) return null
    var [day, month, year] = date.split('/')
    if (!valid_date(year, month, day)) return null
    return `${year.padStart(4, '0')}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  } catch (err){
    console.log(err)
    return null
  }
}

const format_date = function(date){
  // YYYY-MM-DD to DD/MM/YYYY
  try {
    if (!date) return null
    var [year, month, day] = date.split('-')
    if (!valid_date(year, month, day)) return null
    return `${day}/${month}/${year}`
  } catch (err){
    console.log(err)
    return null
  }
}

const date_to_text = function(date){
// date to YYYY-MM-DD
  if (!date) return null
  var mm = date.toLocaleString('en', {month: 'numeric'})
  var dd = date.toLocaleString('en', {day: 'numeric'})
  var yyyy = date.toLocaleString('en', {year: 'numeric'})
  return `${yyyy}-${mm.toString().padStart(2, '0')}-${dd.toString().padStart(2, '0')}`
}

const today_str = function(){
  // today in YYYY-MM-DD
  var d = new Date()
  var mm = d.getMonth() + 1
  var dd = d.getDate()
  var yyyy = d.getFullYear()
  return `${yyyy}-${mm.toString().padStart(2, '0')}-${dd.toString().padStart(2, '0')}`
}


const display_date = function(datestr){
  // input: string representation of date
  // date to display to users only. dd MMM, yyyy
  if (!datestr) return ''
  var date = new Date(datestr.slice(0, 25))
  if (date === Date(null) || isNaN(date.getTime())){
    return 'Unknown'
  } else {
    var yyyy = date.toLocaleString('en', {year: 'numeric'})
    var mmm = date.toLocaleString('en', {month: 'short'})
    var dd = date.toLocaleString('en', {day: 'numeric'})
    return `${dd} ${mmm}, ${yyyy}`
  }
}

const format_ver_time = function(datetimestr){
  // input: string representation of date
  // output: dd MMM, yyyy if the datetime is at midnight sharp, else will also display the time
  if (!datetimestr) return ''
  var datetime = new Date(datetimestr)
  var yyyy = datetime.toLocaleString('en', {year: 'numeric'})
  var mmm = datetime.toLocaleString('en', {month: 'short'})
  var dd = datetime.toLocaleString('en', {day: 'numeric'})
  if (datetime.getHours() == 0 && datetime.getMinutes() == 0 && datetime.getSeconds() == 0){
    return `${dd} ${mmm}, ${yyyy}`
  } else {
    var time = datetime.toLocaleString('en', {hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'})
    return `${dd} ${mmm}, ${yyyy}, ${time}`
  }
}

const time_bracket = function(num_days){
  // input number of full days before today
  // output: [min_date in YYYY-MM-DD, max_date_str=today in YYYY-MM-DD]
  var today = new Date()
  var priorDate = new Date(new Date().setDate(today.getDate() - num_days))
  return [date_to_text(priorDate), date_to_text(today)]
}

const default_time_brackets = {
  'recent7': time_bracket(7),
  'recent30': time_bracket(30),
  'recent1y': time_bracket(365),
  'recent5y': time_bracket(1826)
}

export default{
  parse_date,
  format_date,
  date_to_text,
  today_str,
  display_date,
  format_ver_time,
  time_bracket,
  default_time_brackets
}